module.exports = __webpack_public_path__ + "static/WinStore-c62abca7ab70db62aeb2112afce301ad.png";